import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import React, { useEffect, useState } from "react";
import DownloadButton from "./DownloadButton";
import { Typography } from "@mui/material";

interface ManageResultsParams {
  view: any;
  map: any;
}

const ManageResults: React.FC<ManageResultsParams> = ({ view, map }) => {
  const [count, setCount] = useState<number>(0);
  const [data, setData] = useState<any>();

  useEffect(() => {
    if (!map) return;
    const gl = map.findLayerById("draw");
    if (gl instanceof GraphicsLayer) {
      const handle = gl.graphics.on("change", () => {
        setCount(gl.graphics.length);
        setData(gl.graphics);
      });

      return () => {
        handle.remove();
      };
    }
  }, [map, view]);

  return (
    <>
      <Typography variant="body2">Count: {count}</Typography>
      <>
        <DownloadButton data={data}></DownloadButton>
      </>
    </>
  );
};

export default ManageResults;
